"use client";

import { Component, type ReactNode } from "react";
import { isChunkLoadError, reloadOnceForChunkError } from "@/lib/chunk-reload";

export class ChunkErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    reloadOnceForChunkError(error);
  }

  render() {
    if (this.state.error && !isChunkLoadError(this.state.error)) {
      throw this.state.error;
    }
    return this.props.children;
  }
}
